import { Injectable } from '@angular/core';

import { BehaviorSubject } from 'rxjs'

@Injectable({
    providedIn : "root"  // make this service as singleton service provided by root, no need to set providers in components that use this service
})
export class GoogleMapsApiLoaderService {

    googleMapsApiLoaded$ : BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);
    
    // set apiLoaded(data : boolean) {
    //     this._gmapsApiLoaded$.next(data);
    // }

    // get apiLoaded()
    // {
    //     return this._gmapsApiLoaded$;        
    // }    
}